import dashboard from "./es/dashboard.json";
import translation from "./es/translation.json";
import transport from "./es/transport.json";
import shipment from "./es/shipment.json";
import login from "./es/login.json";
import menu from "./es/menu.json";
import admin from "./es/admin.json";
import finance from "./es/finance.json";
import intransit from "./es/intransit.json";

let items = {
  ...dashboard,
  ...translation,
  ...admin,
  ...login,
  ...menu,
  ...shipment,
  ...transport,
  ...finance,
  ...intransit,
};

export default items;
